import type { TabItem, TabItemType } from '../types';
import { aiAuditHandler } from './aiAuditHandler';
import { callHandler } from './callHandler';
import { eligibilityHandler } from './eligibilityHandler';
import { emailHandler } from './emailHandler';
import { genericTaskHandler } from './genericTaskHandler';
import { humanAuditHandler } from './humanAuditHandler';
import { pendingHumanCallHandler } from './pendingHumanCallHandler';
import { textHandler } from './textHandler';
import type { TabLabelContext, TabTypeHandler } from './types';

export type { TabLabelContext } from './types';

/**
 * Registry of all tab type handlers
 */
const TAB_TYPE_REGISTRY: Record<TabItemType, TabTypeHandler<unknown>> = {
  call: callHandler as TabTypeHandler<unknown>,
  pending_human_call: pendingHumanCallHandler as TabTypeHandler<unknown>,
  eligibility: eligibilityHandler as TabTypeHandler<unknown>,
  generic_task: genericTaskHandler as TabTypeHandler<unknown>,
  text: textHandler as TabTypeHandler<unknown>,
  email: emailHandler as TabTypeHandler<unknown>,
  ai_audit: aiAuditHandler as TabTypeHandler<unknown>,
  human_audit: humanAuditHandler as TabTypeHandler<unknown>,
};

/**
 * Check if a tab type is disabled
 */
export const isTabDisabled = (type: TabItemType): boolean => {
  return TAB_TYPE_REGISTRY[type].isDisabled;
};

/**
 * Get the display label for a tab item
 */
export const getTabLabel = (item: TabItem, context: Omit<TabLabelContext, 'caseState'>): string => {
  const handler = TAB_TYPE_REGISTRY[item.type];
  const caseState = 'case_state' in item.data ? item.data.case_state : undefined;
  return handler.getLabel(item.data, { ...context, caseState });
};

/**
 * Get the popover content component for a tab item
 */
export const getTabPopoverContent = (type: TabItemType) => {
  return TAB_TYPE_REGISTRY[type].PopoverContent;
};
